import { LoginSocialGoogle } from 'reactjs-social-login';
import { styled } from '@mui/material';

import { Button } from '~/components/ui/button';
import TextInput from '~/components/ui/TextInput';
import { TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledFormBodyWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 380,
  marginTop: 40,
  marginBottom: 55,
  '.google-icon': {
    paddingRight: 10,
  },
  '.icon-mail, .icon-locker': {
    color: COLORS.primary,
  },

  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    width: '100%',
    maxWidth: 400,
  },
}));

export const StyledInputWrapper = styled('div')({
  width: '100%',
  margin: '24px 0',
});

export const StyledInput = styled(TextInput)(({ theme }) => ({
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    fontSize: 15,
  },
}));

export const StyledActionsWrapper = styled('div')({
  width: '100%',
  margin: '16px 0',
});

export const StyledDividerTextWrapper = styled('div')({
  width: '100%',
  maxWidth: '350px',
  marginTop: 30,
  marginBottom: 30,
});

export const LoginSocialGoogleStyled = styled(LoginSocialGoogle)(({ theme }) => ({
  width: 'calc(100% - 28px)',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    width: 'calc(100% - 20px)',
  },
}));

export const AuthButton = styled(Button)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    height: 40,
    fontSize: '15px !important',
  },
}));
